import React from 'react';
import './styling/leftBackdrop.css';

export default function LeftBackdrop() {
    return (
        <div className="left-backdrop">
            <div className="backdrop-overlay">
                <h1 className="back-title">
                    Aditya Skill & Educational Training Center
                </h1>
                <p className="back-sub">
                    An ISO 9001:2008 certified. An Autonomous organisation
                </p>
            </div>
        </div>
    );
}